import { Map } from 'immutable';

import {
  ContainerEditActionTypes,
  ContainerEditActions,
  HasItemId,
} from './container-edit.actions';

export function tagsBeingEditedReducer(
  state: Map<string, HasItemId>,
  action: ContainerEditActions,
): Map<string, HasItemId> {
  switch (action.type) {
    case ContainerEditActionTypes.CANCEL_UPDATE_RESOURCE_ITEM_TAGS:
    case ContainerEditActionTypes.CONFIRM_UPDATE_RESOURCE_ITEM_TAGS: {
      const { id } = action.payload;
      return state.remove(id);
    }
    case ContainerEditActionTypes.UPDATE_RESOURCE_ITEM_TAGS: {
      const { id } = action.payload;
      return state.merge({ [id]: action.payload });
    }
    default: {
      return state;
    }
  }
}
